/* Shared bundle roles for DiscountOS.
   Exactly one eligible tee in the cart is tagged _fl_role=full (full price);
   every other eligible tee is _fl_role=additional (the shop-configured amount off via DiscountOS). */
(function () {
  if (window.__flCart) return;
  window.__flCart = true;
  var ROLE = '_fl_role';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var busy = false, again = false, toast;

  function eligible(i) { return (i.vendor || '') === window.FL_VENDOR && i.requires_shipping === true && i.product_type === 'Graphic Apparel'; }
  function role(i) { return (i.properties && i.properties[ROLE]) || ''; }
  function key(v, r) { return v + '|' + r; }
  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }

  function desired(items) {
    var e = items.filter(eligible);
    if (!e.length) return null;
    var first = e.find(function (i) { return role(i) === 'full'; }) || e[0];
    var d = {};
    e.forEach(function (i) {
      var q = i.quantity;
      if (i === first) { d[key(i.variant_id, 'full')] = 1; q -= 1; }
      if (q > 0) { var k = key(i.variant_id, 'additional'); d[k] = (d[k] || 0) + q; }
    });
    return d;
  }
  function actual(items) {
    var a = {};
    items.filter(eligible).forEach(function (i) { var k = key(i.variant_id, role(i)); a[k] = (a[k] || 0) + i.quantity; });
    return a;
  }
  function same(a, b) {
    var ka = Object.keys(a), kb = Object.keys(b);
    return ka.length === kb.length && ka.every(function (k) { return a[k] === b[k]; });
  }
  function req(path, body) {
    return nativeFetch(root + path, {
      method: body ? 'POST' : 'GET', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Cart update failed'); return j; });
    });
  }
  function reconcileOnce() {
    return req('cart.js').then(function (cart) {
      if (window.WQClub) window.WQClub.setCart(cart);
      var d = desired(cart.items);
      if (!d || same(actual(cart.items), d)) return false;
      var left = Object.assign({}, d), updates = {}, adds = [];
      cart.items.filter(eligible).forEach(function (i) {
        var k = key(i.variant_id, role(i)), want = left[k] || 0, keep = Math.min(want, i.quantity);
        updates[i.key] = keep; left[k] = want - keep;
      });
      Object.keys(left).forEach(function (k) {
        if (left[k] > 0) { var p = k.split('|'), props = {}; props[ROLE] = p[1]; adds.push({ id: +p[0], quantity: left[k], properties: props }); }
      });
      return req('cart/update.js', { updates: updates })
        .then(function () { return adds.length ? req('cart/add.js', { items: adds }) : null; })
        .then(function () { return true; });
    });
  }
  function show(on) {
    if (on && !toast) {
      toast = document.createElement('div');
      toast.setAttribute('role', 'status');
      toast.textContent = 'Applying your bundle savings…';
      toast.style.cssText = 'position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:2147483000;padding:10px 18px;border-radius:24px;background:#1B1B1A;color:#FBF8F1;font:14px/1.4 sans-serif;box-shadow:0 3px 18px #0003;pointer-events:none';
      document.body.appendChild(toast);
    }
    if (toast) toast.hidden = !on;
  }
  // Re-render the cart drawer / cart page in place instead of reloading.
  function refresh() {
    var d = document.querySelector('m-cart-drawer');
    var open = !!(d && (d.classList.contains('m-cart-drawer--active')));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: open } }));
  }
  function run(reloadIfChanged) {
    if (busy) { again = true; return Promise.resolve(false); }
    busy = true;
    var changed = false;
    return reconcileOnce()
      .then(function (c) { changed = c; if (c) { show(true); return reconcileOnce(); } })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; return run(reloadIfChanged); }
        if (changed && reloadIfChanged) { refresh(); }
        show(false);
        return changed;
      });
  }

  // Re-check after any cart change made by the theme (quick add, drawer, cart page).
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { run(true); }, function () {});
    }
    return p;
  };

  // Always fix the roles before checkout.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!t) return;
    e.preventDefault(); e.stopImmediatePropagation();
    show(true);
    run(false).then(function () { location.href = root + 'checkout'; });
  }, true);

  function start() { run(true); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
